export const enum VoidingPlaceEnum {
  TOILET = "toilet",
  NAPPY = "nappy",
  BED = "bed",
  FLOOR = "floor",
  OTHER = "other",
}

export const VoidingPlaceDropdownOptions = [
  { value: VoidingPlaceEnum.TOILET, label: "Toilet" },
  { value: VoidingPlaceEnum.NAPPY, label: "Nappy" },
  { value: VoidingPlaceEnum.BED, label: "Bed" },
  { value: VoidingPlaceEnum.FLOOR, label: "Floor" },
  { value: VoidingPlaceEnum.OTHER, label: "Other" },
];
